<template>
  <div class="discovery-item-tooltip" ref="tooltip">
    <a :href="JsPAPI.util.itemURL(
      item,
      JsPAPI.api.getConfig(),
    )">
      <div class="discovery-tooltip-header">
        {{ item.Title }}
        <div v-if="item.Author" class="discovery-tooltip-author">
          {{ item.Author }}
        </div>
      </div>
    </a>
    <div class="discovery-tooltip-content">
      <div v-if="item.Summary" class="discovery-tooltip-summary">
        {{ JsPAPI.util.truncate(item.Summary, 256) }}
        <hr>
      </div>
      <div v-if="item.TargetAudience" class="discovery-tooltip-audience">
        Audience: {{ item.TargetAudience }}
      </div>
      <div v-if="item.PublicationDate" class="discovery-tooltip-published">
        Published: {{ item.PublicationDate }}
      </div>
      <div class="discovery-tooltip-availability">
        Available: {{ item.SystemItemsIn }} of {{ item.SystemItemsTotal }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ItemTooltip',
  mounted() {
    // Add tooltip
    tippy(this.$parent.$el, {
      content: this.$refs.tooltip,
      placement: 'left',
      theme: 'light',
      interactive: false,
      delay: 0,
    });
  },
  props: {
    item: {},
  },
};
</script>

<style lang="less">
@import '~@/css/global';

.discovery-item-tooltip {
  background: var(--white);
  color: var(--gray-dark);
  width: 300px;
  a, a:hover {
    text-decoration: none;
  }
}
.discovery-tooltip-header {
  background-color: @gray-dark;
  color: @white;
  text-transform: capitalize;
  padding: @pad-md;
  font-size: 16pt;
  line-height: 16pt;
}
.discovery-tooltip-author {
  font-size: 12pt;
  line-height: 12pt;
  margin-top: 0.5rem;
}
.discovery-tooltip-content {
  padding: 0.5rem;
  font-size: 14pt;
}
.discovery-tooltip-label {
  font-weight: bold;
}
</style>
